import { useState } from "react";
import { Link } from "react-router-dom";
import AuthHeader from "../components/AuthHeader";

const ResetPassword = () => {
  const [input, setInput] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // trigger reset email/sms logic here
  };

  return (
    <div className="min-h-screen bg-[#fdf6ee] font-sans relative overflow-hidden">
      <AuthHeader />

      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-4 w-full max-w-md space-y-6">
        <h2 className="text-3xl font-bold text-center">Reset Your Password</h2>
        <p className="text-sm text-gray-600 text-center">
          Enter your email or phone number and we'll send reset instructions.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Email or Phone Number"
            className="w-full px-4 py-3 rounded-full border border-gray-300"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            required
          />
          <button
            type="submit"
            className="w-full bg-black text-white rounded-full px-6 py-3 hover:bg-gray-900 transition"
          >
            Send Reset Instructions
          </button>
        </form>

        <div className="text-center text-sm mt-2">
          <Link to="/login" className="underline text-black">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
